import AppLayout from '@/layout/AppLayout.vue'
const WithdrawMoney = () => import('@/view/withdrawMoney/WithdrawMoney.vue')

const routes = {
  path: '/WithdrawMoney',
  name: 'WithdrawMoney',
  icon: 'icon-a-lianhe39',
  meta: {
    title: 'withdrawMoney.depositAndWithdrawData'
  },
  component: WithdrawMoney,
}

const components = {}

export default {
  routes,
  components,
}
